import AudioJungleItemCard from './audioJungleItemCard'

export default AudioJungleItemCard
